import React from 'react';
import { Settings, Clock, Mail, ArrowRight } from 'lucide-react';
import './MaintenancePage.css';

const MaintenancePage = ({ message, estimatedReturn, contactEmail }) => {
  return (
    <div className="maintenance-page">
      <div className="maintenance-content">
        <div className="maintenance-logo">
          <span className="logo-aurora">Aurora</span>
          <span className="logo-seafood">Seafood</span>
        </div>

        <div className="maintenance-icon">
          <Settings size={48} color="#29ABE2" strokeWidth={1} />
        </div>

        <div className="maintenance-badge">
          Under Maintenance
        </div>

        <h1 className="maintenance-title">
          We'll Be Back Soon
        </h1>

        <p className="maintenance-message">
          {message ||
            "We're currently performing scheduled maintenance to improve your experience. Thank you for your patience!"}
        </p>

        {estimatedReturn && (
          <div className="maintenance-eta">
            <Clock size={18} color="#29ABE2" />
            <span>
              Estimated return: <strong>{estimatedReturn}</strong>
            </span>
          </div>
        )}

        <div className="maintenance-features">
          <div className="maintenance-feature">
            <div className="feature-dot" />
            <span>Fresh seafood products</span>
          </div>
          <div className="maintenance-feature">
            <div className="feature-dot" />
            <span>Loyalty rewards program</span>
          </div>
          <div className="maintenance-feature">
            <div className="feature-dot" />
            <span>Secure payments</span>
          </div>
        </div>

        {contactEmail && (
          <a
            href={`mailto:${contactEmail}`}
            className="maintenance-contact"
          >
            <Mail size={16} />
            Contact us at {contactEmail}
            <ArrowRight size={16} />
          </a>
        )}

        <p className="maintenance-footer">
          © {new Date().getFullYear()} Aurora Seafood. All rights reserved.
        </p>
      </div>

      <div className="maintenance-decoration">
        <div className="decoration-circle decoration-circle-1" />
        <div className="decoration-circle decoration-circle-2" />
        <div className="decoration-circle decoration-circle-3" />
      </div>
    </div>
  );
};

export default MaintenancePage;